import Cookies from '../lib/cookies';

const ratingModal = document.querySelector('.js-coffee-rating-modal');
const ratingButtons = document.querySelectorAll('.js-coffee-rating-star');
const ratingWrapper = document.querySelector('.js-coffe-rating-wrapper');
const ratingModalBtn = document.querySelector('.js-coffee-rating-modal-button');
const ratingOverlay = document.querySelector('.js-coffe-rating-overlay');
const ratingStars = document.querySelectorAll('.js-coffee-rating-star');
const ratingThankYou = document.querySelector('.js-coffee-rating-thank-you');
const body = document.querySelector('body');
const numberOfStars = 5;
const url = `/CoffeeRecipeRating/SaveRating/`;
var pageId;
var cookieName = 'CoffeeRecipeRating-';
var cookie;

const handleModalBtnClick = e => {
  if (ratingModal) {
    ratingModal.setAttribute('aria-hidden', false);
  }

  if (ratingOverlay) {
    ratingOverlay.setAttribute('aria-hidden', false);
  }
};

const getSvg = i => {
  const star = document.querySelector(`[data-rating="${i}"]`);
  const svg = star.querySelector('svg');
  return svg;
};

const handleStarHover = e => {
  const current = e.currentTarget;

  for (var i = 1; i <= current.dataset.rating; i++) {
    const svg = getSvg(i);

    if (svg) {
      svg.classList.add('c-coffee-rating__star--active');
    }
  }

  for (var i = parseInt(current.dataset.rating) + 1; i <= numberOfStars; i++) {
    const svg = getSvg(i);

    if (svg && svg.classList.contains('c-coffee-rating__star--active')) {
      svg.classList.remove('c-coffee-rating__star--active');
    }
  }
};

const clearStarActive = () => {
  ratingStars.forEach(star => {
    const svg = star.querySelector('svg');

    if (svg && svg.classList.contains('c-coffee-rating__star--active')) {
      svg.classList.remove('c-coffee-rating__star--active');
    }
  });
};

const handleRatingSubmit = (e, pageId) => {
  const target = e.currentTarget;
  const rating = parseInt(target.dataset.rating);

  if (!cookie || !cookie.includes(pageId)) {
    fetch(url, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json; charset=UTF-8',
        'X-Requested-With': 'XMLHttpRequest',
      },
      body: JSON.stringify({ pageID: pageId, rating: rating }),
    }).then(
      Cookies.set(
        cookieName,
        JSON.stringify({ pageID: pageId, rating: rating }),
        1,
      ),
    );

    if (ratingWrapper) {
      ratingWrapper.setAttribute('aria-hidden', true);
    }

    if (ratingThankYou) {
      ratingThankYou.setAttribute('aria-hidden', false);
    }
  }
};

export const recipeRating = () => {
  if (ratingWrapper) {
    pageId = parseInt(ratingWrapper.dataset.pageId);
    cookieName = cookieName + pageId;
    cookie = Cookies.get(cookieName);

    if (!cookie || !cookie.includes(pageId)) {
      ratingWrapper.setAttribute('aria-hidden', false);
    }
  }

  body.addEventListener('click', function(e) {
    if (
      ratingModal &&
      !ratingModalBtn.contains(e.target) &&
      ratingModal.getAttribute('aria-hidden') == 'false'
    ) {
      ratingModal.setAttribute('aria-hidden', true);

      if (ratingOverlay) {
        ratingOverlay.setAttribute('aria-hidden', true);
      }
    }
  });

  if (ratingModalBtn) {
    ratingModalBtn.addEventListener('click', handleModalBtnClick);
  }

  if (ratingStars.length) {
    ratingStars.forEach(star => {
      star.addEventListener('mouseover', handleStarHover);
    });

    ratingStars.forEach(star => {
      star.addEventListener('mouseleave', clearStarActive);
    });
  }

  if (ratingButtons.length && pageId) {
    ratingButtons.forEach(button => {
      button.addEventListener('click', function(e) {
        handleRatingSubmit(e, pageId);
      });
    });
  }
};
